import BaseService from '@src/services/BaseService'

class TrackingUsers extends BaseService {
    constructor() {
        super('user-tracking/from-user-on-date')
    }
}

export default new TrackingUsers()
